import React from 'react'
import PropTypes from 'prop-types'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'

import HeaderSubNavDropdownNav from './Nav/Nav'
import HeaderSubNavDropdownCollections from './Collections/Collections'
import HeaderSubNavDropdownProduct from './Product/Product'
import HeaderSubNavDropdownCard from './Card/Card'
import HeaderSubNavDropdownText from './Text/Text'

import s from './HeaderSubNavDropdown.scss'


const HeaderSubNavDropdown = ({ items, state, setState, _ref }) => {

  let adaIndex = -1

  const getAdaIndex = () => adaIndex += 1

  const children = items.map((item, index) => {
    const { type } = item

    if (type === 'nav') {
      const itemNav = item.nav.map((navItem) => ({ ...navItem, adaIndex: navItem.to ? getAdaIndex() : null }))

      return (
        <HeaderSubNavDropdownNav
          key={index}
          className={s.item}
          items={itemNav}
          {...{ _ref, state, setState }}
        />
      )
    }

    if (type === 'collections') {
      const adaIndexMenu      = getAdaIndex()
      const itemCollections   = item.collections.map((collection) => ({ ...collection, adaIndex: getAdaIndex() }))
      const adaIndexBrowseAll = getAdaIndex()

      return (
        <HeaderSubNavDropdownCollections
          key={index}
          className={s.item}
          titleProps={item.titleProps}
          browseAllProps={item.browseAllProps}
          collections={itemCollections}
          placement={item.placement}
          isFetching={item.isFetching}
          {...{ _ref, state, setState, adaIndexMenu, adaIndexBrowseAll }}
        />
      )
    }

    if (type === 'product') {
      const itemProductTitleAdaIndex  = getAdaIndex()
      const itemProductAdaIndex       = getAdaIndex()

      return (
        <HeaderSubNavDropdownProduct
          key={index}
          className={s.item}
          titleProps={item.titleProps}
          adaIndex={itemProductAdaIndex}
          titleAdaIndex={itemProductTitleAdaIndex}
          product={item.product}
          addButtonProps={item.addButtonProps}
          placement={item.placement}
          hideBrand={item.hideBrand}
          subtitle={item.subtitle}
          isFetching={item.isFetching}
          {...{ _ref, state, setState }}
        />
      )
    }

    if (type === 'card') {
      const itemCardAdaIndex = getAdaIndex()

      return (
        <HeaderSubNavDropdownCard
          key={index}
          className={s.item}
          imageContainerClassName={item.imageContainerClass}
          adaIndex={itemCardAdaIndex}
          title={item.title}
          to={item.to}
          image={item.image}
          badge={item.badge}
          small={item.small}
          transparent={item.transparent}
          dataTestId={item.dataTestId}
          onClick={item.onClick}
          _ref={_ref(itemCardAdaIndex)}
          {...{ state, setState }}
        />
      )
    }

    if (type === 'text') {
      return (
        <HeaderSubNavDropdownText
          key={index}
          className={s.item}
          text={item.text}
          {...{ _ref, state, setState }}
        />
      )
    }

    return null
  })
    .filter((item) => Boolean(item))

  return (
    <WidthContainer>
      <div className={s.root}>
        <div className={s.grid}>
          {children}
        </div>
      </div>
    </WidthContainer>
  )
}

HeaderSubNavDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
}


export default HeaderSubNavDropdown
